import { Table, Spin, message, Image, Form, Space, DatePicker, Radio, Divider, Select, Button, Tooltip, Input, InputNumber, Modal } from 'antd';
import dayjs from 'dayjs';
import debounce from 'lodash/debounce';
import APIUtils from '../../api/APIUtils';
import WebLinks from '../../api/WebLinks';
import { useEffect, useState } from 'react';
import constants from '../../constants/constants';
import Cookies from 'js-cookie';
import { useContext } from 'react';
import moment from 'moment';
import { CommonContext, CurrencyContext } from '../../Context';
import { getCurrencyName, trackPageAccess } from '../../globalFunctions/GlobalFunctions';

const { Column } = Table;
const { RangePicker } = DatePicker;
const { Option } = Select

const Orders = (props) => {
	//Variable Declaration
	const commonContext=useContext(CommonContext);
	const buyerId = commonContext.common.buyerId;
	const currencyContext=useContext(CurrencyContext);
	const [ordersData, setOrders] = useState([]);
	const [suppliers, setSuppliers] = useState([]);
	const [pageNumber, setPageNumber] = useState(1);
	const [sortDesc, setSortDesc] = useState(false);
	const [total, setTotal] = useState(0);
	const [loading, setloading] = useState(false);
	const [rangePickerValue, setRangePickerValue] = useState([]);
	const [suplierListLoader,setSuplierListLoader]= useState(false);
	const [allowedSupplierList, setAllowedSupplierList] = useState([]);
  const [selectedSupplierIds,setSelectedsupplierIds]=useState([]);
	const [type, setType] = useState(1);
	const [isEditModalOpen, setIsEditModalOpen] = useState(false);
	const [form] = Form.useForm();
	const [formCreate] = Form.useForm();
	const isSelfService= sessionStorage.getItem('isSelfService');
	const isBoost= sessionStorage.getItem('isBoost');
	const options = Array.from({ length: 20 }, (_, i) => (i + 1) * 500);
  const optionsFree = Array.from({ length: 20 }, (_, i) => (i + 1) * 50);
  const [isHIAdmin,setIsHIAdmin]=useState(false);
  const [paymentType, setPaymentType] = useState(null); // Default payment type
  const AllowCreditInvoicing = sessionStorage.getItem('allowCreditInvoicing');
	const [purchaseLoader,setPurchaseLoader]=useState(false);
const [isCreditInvoiceModalOpen, setIsCreditInvoiceModalOpen] = useState(false);
	const [creditInvoiceForm] = Form.useForm();
	const [countryList, setCountryList] = useState([]);
	const [countryLoader, setCountryLoader] = useState(false);
	const [hasSubmittedCreditInvoice, setHasSubmittedCreditInvoice] = useState(false);
	const [showCreditInvoiceSuccessMessage, setShowCreditInvoiceSuccessMessage] = useState(false);
	const [openTopupAfterCreditInvoiceClose, setOpenTopupAfterCreditInvoiceClose] = useState(false);
  // Table columns
  const columns = [
		{
			title: 'Billing Start',
			dataIndex: 'startOfBillingDate',
			key: 'startOfBillingDate',
			render: (startOfBillingDate) => {
					 {return<span className='whitespace-nowrap'><p>{moment(startOfBillingDate).format('YYYY-MM-D')}</p></span>}
			},
			sorter: (a, b) => moment(a.startOfBillingDate).unix() - moment(b.startOfBillingDate).unix(),
		},
		{
			title: 'Billing End',
			dataIndex: 'endOfBillDate',
			key: 'endOfBillDate',
			render: (endOfBillDate) => {
					{return<span className='whitespace-nowrap'><p>{moment(endOfBillDate).format('YYYY-MM-D')}</p></span>}
			},
			sorter: (a, b) => moment(a.endOfBillDate).unix() - moment(b.endOfBillDate).unix(),
		},
    {
			title:"Suppliers",
			dataIndex: 'suppliers',
			key: 'suppliers',
			width: '20%',
			render: (text, record, index) =>
			<>
				{ record.logoURL && record.logoURL!==""? <Image src={record.logoURL} preview={false} width={100}/> : <span className='uppercase font-bold text-gray-400'>{record.supplierName} </span>}
			</>
		},
    {
			title: 'Product',
			dataIndex: 'productName',
			key: 'productName',
			sorter: (a, b) => a.productName - b.productName,
    },
    {
			title: 'Product Type',
      dataIndex: 'productType',
      key: 'productType',
      sorter: (a, b) => a.productType - b.productType,
    },
    {
      title: 'Billing Period',
      dataIndex: 'billingPeriod',
      key: 'billingPeriod',
      sorter: (a, b) => a.billingPeriod.localeCompare(b.billingPeriod),
    },
		{
			title: 'Contract Start',
			dataIndex: 'startOfContract',
			key: 'startOfContract',
			render: (startOfContract) => {
					 {return<span className='whitespace-nowrap'><p>{moment(startOfContract ).format('YYYY-MM-D')}</p></span>}
			},
			sorter: (a, b) => moment(a.startOfContract ).unix() - moment(b.startOfContract ).unix(),
		},
		{
			title: 'Contract End',
			dataIndex: 'endOfContract',
			key: 'endOfContract',
			render: (endOfContract) => {
					{return<span className='whitespace-nowrap'><p>{moment(endOfContract ).format('YYYY-MM-D')}</p></span>}
			},
			sorter: (a, b) => moment(a.endOfContract ).unix() - moment(b.endOfContract ).unix(),
		},
    {
      title: 'Contract Period',
      dataIndex: 'contractPeriod',
      key: 'contractPeriod',
      sorter: (a, b) => a.contractPeriod.localeCompare(b.contractPeriod),
    },
		{
			title: 'Invoice Details',
			key: 'invoiceDetails',
			render: (_, record) => {
				const details = record?.invoiceDetails;
				if (!details) return '';

				return record?.id ? `${record.id} - ${details}` : details;
			},
			sorter: (a, b) => a?.invoiceDetails?.localeCompare(b?.invoiceDetails),
		},
    {
      title: 'Invoice Currency',
      dataIndex: 'invoiceCurrency',
      key: 'invoiceCurrency',
      //sorter: (a, b) => a.invoiceCurrency - b.invoiceCurrency,
    },
    {
      title: 'Invoice Amount',
      dataIndex: 'invoiceAmount',
      key: 'invoiceAmount',
      sorter: (a, b) => a.invoiceAmount - b.invoiceAmount,
    },
		{
      title: 'Invoice ID',
      dataIndex: 'invoiceId',
      key: 'invoiceId',
      sorter: (a, b) => a.invoiceId - b.invoiceId,
    },
  ];
	//On page load
	useEffect(() => {
    const isAdmin = Cookies.get(constants.COOKIE_IS_ADMIN);
    setIsHIAdmin(isAdmin==="true"?"true":"false");
		trackPageAccess(buyerId,window.location.href)
    //setIsHIAdmin("false")
  }, []);
	useEffect(() => {
		const date1 = dayjs().startOf('month')
		const date2 = dayjs().endOf('month')
		form.setFieldsValue({
			rangePicker: [
				date1,
				date2,
			],
		});
		setRangePickerValue([
			date1,
			date2
		]);
		fetchData(date1.format('YYYY-MM-DD'), date2.format('YYYY-MM-DD'),type,null);
		getAllowedSuppliers();
		fetchCountryList();

	}, [props]);

	//Functions
	//Function to fetch orders data
	const fetchData = async (date1, date2,type,supplierids) => {
		setloading(true);
		let url=WebLinks.GetOrders + buyerId +
		'&fromDate=' + date1 + '&toDate=' + date2 + '&filter=' + type;
		if(supplierids&&supplierids.length>0){
			url= url+"&supplierId="+supplierids
		}
		const orders = await APIUtils.apiCall("GET", url, null);
		if (orders.isCatch) {
			message.error(constants.ERROR_MESSAGE);
		} else {
			if (orders.resultObj?.statusCode === "2000") {
				setOrders(orders.resultObj.data)
				setTotal(orders.resultObj.data?.getCount | 0);
			} else {
				setOrders([]);
				setTotal(0);
				message.success(orders.resultObj?.message | constants.ERROR_MESSAGE)
			}
		}
		setloading(false);
	}

  //Set default currency
  const setDefaultCurrency=()=>{
    let curr=getCurrencyName(currencyContext.currency);
    formCreate.setFieldsValue({
      invoiceCurrency:curr
    })
  };

  const handleCancel = () => {
    formCreate.resetFields();
    setIsEditModalOpen(false);
  };

	const handleOpenTopupModal = () => {
		setShowCreditInvoiceSuccessMessage(false);
		setIsEditModalOpen(true);
		setDefaultCurrency();
	};
	
	//Function to get Allowed suppliers list
	const getAllowedSuppliers =async()=>{
		setSuplierListLoader(true);
		const response = await APIUtils.apiCall('GET',WebLinks.GetALlAllowedSuppliersAllowedOrders);
		if(!response.isCatch && response.resultObj.statusCode==="2000"){
			setAllowedSupplierList(response?.resultObj?.data||[])
			setSuplierListLoader(false);
		}else{
			setAllowedSupplierList([]);
			setSuplierListLoader(false);
			message.error(response.resultObj.message);
		}
	}

	const changeType = (radio) => {
		setType(radio.target.value)
		fetchData(rangePickerValue[0].format('YYYY-MM-DD'), rangePickerValue[1].format('YYYY-MM-DD'), radio.target.value,selectedSupplierIds);
	}

 	//Function on change of supplier selection
	const handleSupplierSelect=(selectedSuppliers)=>{
		if(selectedSuppliers.length>0){
			let tempSelectedSuppliers=selectedSuppliers.filter(value => value !== 'showall');
			let selectedSuppliersFinal=tempSelectedSuppliers.length>0?tempSelectedSuppliers:"";
			form.setFieldsValue({
				supplierList:selectedSuppliersFinal
			})
			setSelectedsupplierIds(selectedSuppliersFinal);
			fetchData(rangePickerValue[0].format('YYYY-MM-DD'), rangePickerValue[1].format('YYYY-MM-DD'), type,selectedSuppliersFinal);
		}else{
			form.setFieldsValue({
				supplierList:["showall"]
			})
			setSelectedsupplierIds([]);
			fetchData(rangePickerValue[0].format('YYYY-MM-DD'), rangePickerValue[1].format('YYYY-MM-DD'), type,null);
		}
	}

	const RangePickerChanged = debounce((_, dateStrings) => {
		const date1 = dayjs(dateStrings[0], constants.MonthFormat)
		const date2 = dayjs(dateStrings[1], constants.MonthFormat)
		setRangePickerValue([
			date1,
			date2
		]);
		fetchData(date1.format('YYYY-MM-DD'), date2.format('YYYY-MM-DD'),type,selectedSupplierIds);
	}, 500);

  //Function to save edited job
	const saveDetails = async (values) => {
		setPurchaseLoader(true);
    let payload = {
      buyerId: buyerId,
      contractAmount: values?.contractAmount,
			invoiceAmount: values?.contractAmount,
      createdByBuyerId: Cookies.get(constants.COOKIE_LOGGED_BUYER_ID),
      purchaseOrderInfo: values?.orderInfo,
			billingDateStart:moment().format('YYYY-MM-DD'),
			billingDateEnd:moment().format('YYYY-MM-DD'),
      type: paymentType,
      confirmerName : values?.userName,
			freeCredits:paymentType==="free"?true:false,
      doNotInvoice:paymentType==="free"?1:0 
    }
      let method, url, body;
      method = "POST";
      url = WebLinks.AddOrderContractAmountDetails;
      const response = await APIUtils.apiCall(method, url,JSON.stringify(payload));
      if (!response.isCatch || response.resultObj.statusCode === "2000") {
        if(paymentType==="card"|| (AllowCreditInvoicing==="false" && isHIAdmin==="false" && !hasSubmittedCreditInvoice)){
          createCheckoutSession(values?.contractAmount,response.resultObj.buyerOrdersId);
          return;
       }else{
				setPurchaseLoader(false);
        commonContext.changeCommonValues({'boostCredits':response.resultObj?.boostCredits||0});
        handleCancel();
        message.success(response.resultObj.message);
       }
      } else {
				setPurchaseLoader(false);
        handleCancel();
        message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
    }
  };

	const createCheckoutSession = async (amount,buyerOrdersId) => { 
    let payload = {
      buyerId: buyerId,
      amount: amount,
      currency: getCurrencyName(currencyContext.currency),
      productName: "Credit Top Up",
      buyerOrdersId: buyerOrdersId
    }
    let method, url, body;
    method = "POST";
    url = WebLinks.CreateStripeSession;
    const response = await APIUtils.apiCall(method, url,JSON.stringify(payload));
    if (!response.isCatch || response.resultObj.statusCode === "2000") {
			setPurchaseLoader(false);
      window.location.href = response.resultObj.data;
      //message.success(response.resultObj.message);
    } else {
			setPurchaseLoader(false);
      message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
    }
  };
	const handleOpenCreditInvoiceModal = () => {
		setIsCreditInvoiceModalOpen(true);
	};

	const handleCloseCreditInvoiceModal = () => {
		creditInvoiceForm.resetFields();
		setIsCreditInvoiceModalOpen(false);
	};

	const handleSaveCreditInvoice = async (values) => {
		const payload = {
			buyerId: buyerId,
			companyLegalName: values?.companyLegalName,
			companyCity: values?.companyCity||"",
			companyAddress: values?.companyAddress||"",
			companyState: values?.companyState||"",
			companyZip: values?.companyZip||"",
			companyCountry: values?.companyCountry,
			invoiceEmail: values?.invoiceEmail,
			createdByBuyerId: Cookies.get(constants.COOKIE_LOGGED_BUYER_ID),
		};
		const response = await APIUtils.apiCall('POST', WebLinks.PostCreditInvoice, JSON.stringify(payload));
			if (!response.isCatch && response.resultObj && response.resultObj.statusCode === "2000") {
				message.success(response?.resultObj?.message );
				if (isSelfService === "true") {
					setHasSubmittedCreditInvoice(true);
					setPaymentType("invoice");
					formCreate.setFieldsValue({ type: "invoice" });
					setOpenTopupAfterCreditInvoiceClose(true);
				}
				handleCloseCreditInvoiceModal();
			} else {
				message.error(response?.resultObj?.message || constants.FAILED_SAVE);
			}
	};
		//Country list
	const fetchCountryList = async () => {
			setCountryLoader(true)
			const response = await APIUtils.apiCall("GET", WebLinks.GetCountryList);
			if (!response.isCatch) {
				setCountryList(response.resultObj.data)
			} else {
				message.error(response.resultObj.message);
			}
			setCountryLoader(false);
	}
	const handlePaymentTypeChange = (e) => {
		const type = e.target.value;
		setPaymentType(type);
		// Clear amount when switching payment methods
		formCreate.resetFields(['contractAmount']);
	};
	//Render
	return (
    <>
    <div className='uppercase font-bold text-xl'>Billing</div>
			<Divider className='my-3'/>
		<div>
			<div className='flex flex-wrap gap-3 justify-between items-center mb-3'>
				<Space wrap>
					<Form form={form}>
						<Space wrap>
						<Form.Item name="rangePicker" className='mb-0'>
							<RangePicker picker="month"
								placeholder={["From", "To"]}
								onChange={RangePickerChanged}
								format={constants.MonthFormat} />
						</Form.Item>
						<Form.Item name="supplierList" className='mb-0'>
              <Select
                loading={suplierListLoader}
                className='!w-60'
                // value={selectedSupplier || []}
                placeholder={constants.supplierName}
                mode='multiple'
                allowClear
                defaultValue={"showall"}
                showSearch
              filterOption={(input, option) =>
                  option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
                onChange={(e) => handleSupplierSelect(e)}
                >
                  <Option key='showall' value='showall'>Show all</Option>
                    {allowedSupplierList?.map((supplier) => (
                      <Option key={supplier.supplierId}
                          value={supplier.supplierId}
                      >
                      {supplier.name}</Option>
                ))}
              </Select>
            </Form.Item>
						</Space>
					</Form>
					{isSelfService==="true"||isBoost==="true"?
					<Tooltip placement='right' title={constants.BuyBoostCredits}>
            <Button onClick={handleOpenTopupModal} className="bg-green-800 text-white hover:!text-white hover:!border-green-500" > {constants.BuyBoostCredits}</Button>
          </Tooltip>
					:null}
				</Space>
				<Space wrap>
					<Radio.Group name="radiogroup" defaultValue={type} onChange={changeType}>
						<Radio value={1}>Billing Start</Radio>
						<Radio value={2}>Billing End</Radio>
            <Radio value={3}>Contract Start</Radio>
            <Radio value={4}>Contract End</Radio>
					</Radio.Group>
				</Space>
			</div>
			<div className='overflow-x-auto'>
			<Table
          loading={loading}
          size='small'
          pagination={{
            //current: pagination.current,
            showSizeChanger: true,
            pageSizeOptions: ["200", "500", "1000", "2000"],
            defaultPageSize: 200,
            // onChange: (page, pageSize) => {
            //   setPagination({
            //     current: page,
            //     pageSize: pageSize
            //   });
            // }
          }}
          columns={columns}
          dataSource={ordersData}
          //onChange={(pagination, filters, sorter, extra)=>setCount(extra?.currentDataSource?.length||0)}
        />
			</div>
			<Modal
        title={constants.BuyBoostCredits}
        open={isEditModalOpen}
        onCancel={handleCancel}
        destroyOnClose
        //okText={<span className="capitalize">Save</span>}
       // onOk={() => form.submit()}
        style={{ top: 20 }}
        width={800}
        footer={paymentType!==null || AllowCreditInvoicing==="false" ?
          [
          <Button key="cancel" onClick={()=>handleCancel()}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" loading={purchaseLoader} onClick={()=>formCreate.submit()}>
            PURCHASE
          </Button>,
        ]:[]
      }
      >
        <Form form={formCreate} name="form_in_modal" layout="vertical" onFinish={saveDetails}>
          <div >
            {showCreditInvoiceSuccessMessage && (
              <p className="mb-4 font-semibold">
                Thanks for providing your invoicing details. Please purchase some Top Up Credits
              </p>
            )}
            {AllowCreditInvoicing==="true"?<>
              <Form.Item
                label="Select Payment Type"
                name="type"
              >
									<Radio.Group onChange={handlePaymentTypeChange}>
                    <Radio value="card">Card Payment</Radio>
                    <Radio value="invoice">Invoice</Radio>
                  {Cookies.get(constants.COOKIE_IS_ADMIN) === "true" || Cookies.get(constants.COOKIE_IS_ADMIN) === true ? (
                    <Radio value="free">Free Credits</Radio>
                  ):null}
                </Radio.Group>
              </Form.Item>
            </>:
						Cookies.get(constants.COOKIE_IS_ADMIN) === "true" || Cookies.get(constants.COOKIE_IS_ADMIN) === true ? 
						<Form.Item
							label="Select Payment Type"
							name="type"
						>
							<Radio.Group onChange={handlePaymentTypeChange}>
									<Radio value="card">Card Payment</Radio>
									<Radio value="free">Free Credits</Radio>
							</Radio.Group>
						</Form.Item>           
					:AllowCreditInvoicing==="false" && hasSubmittedCreditInvoice?
						<Form.Item
							label="Select Payment Type"
							name="type"
						>
							<Radio.Group onChange={handlePaymentTypeChange}>
								<Radio value="card">Card Payment</Radio>
								<Radio value="invoice">Invoice</Radio>
								{Cookies.get(constants.COOKIE_IS_ADMIN) === "true" || Cookies.get(constants.COOKIE_IS_ADMIN) === true ? (
									<Radio value="free">Free Credits</Radio>
								):null}
							</Radio.Group>
						</Form.Item>
					:AllowCreditInvoicing==="false"?
							<Space>
								<Form.Item
									label="Select Payment Type"
									name="typer"
								>
									<Radio.Group name='radio' defaultValue="card">
											<Radio value="card">Card Payment</Radio>
									</Radio.Group>
								</Form.Item>
								<Form.Item><Button className='mt-7' type="link" onClick={handleOpenCreditInvoiceModal}>Apply for Credit Invoicing</Button></Form.Item>
								</Space>:
						null}
            {paymentType!==null || AllowCreditInvoicing==="false" ?
            <>
            <Form.Item
              name="contractAmount"
              label={`Credit Amount ${getCurrencyName(currencyContext.currency)}`}
              rules={[
                {
                  required: true,
                  message: "Required field",
                },
                {
                  validator: (_, value) =>
                    value == null || value === "" || Number(value) >= 50
                      ? Promise.resolve()
											: Promise.reject(new Error("Minimum credit amount must be 50.")),
                },
              ]}
            >
              {/* <InputNumber min={0} className='w-full' placeholder="Amount"/> */}
							{(paymentType === "free" || paymentType === "card") ?
              	<InputNumber
									controls={false}
									className="w-full"
									placeholder="Enter amount"
									parser={(value) => value?.replace(/[^\d.]/g, '')}
									onKeyDown={(e) => {
										const allowedKeys = [
											"Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Home", "End",
										];
										if (
											!/[0-9.]/.test(e.key) &&
											!allowedKeys.includes(e.key) &&
											!(e.ctrlKey || e.metaKey)
										) {
											e.preventDefault();
										}
										// Allow only one decimal point
										if (e.key === "." && e.currentTarget.value.includes(".")) {
											e.preventDefault();
										}
									}}
								/>:
							<Select placeholder="Choose amount">
								{options.map((value) => (
									<Option key={value} value={value}>
										{value}
									</Option>
								))}
							</Select>}
            </Form.Item> 
            {paymentType!=="card"?
            <>
            {isHIAdmin==="false"&&AllowCreditInvoicing==="false"&&!hasSubmittedCreditInvoice?null:
            <>
            {paymentType==="invoice"?
						<>    
            <Form.Item name="orderInfo" label="Purchase Order Info. (optional)"
            >
            <Input placeholder='Order Info.'/>
           </Form.Item>
					 <Form.Item name="userName" label="Please enter your name to confirm"
					 >
					 <Input placeholder='Name'/>
					</Form.Item>
					</>
					 :
            <Form.Item name="orderInfo" label="Purchase Order Info. (optional)"
						>
						<Input placeholder='Order Info.'/>
					 </Form.Item>
            }
            </>           
            }
           </>:null}
           </>:null}
          </div>       
        </Form>
      </Modal>
			<Modal
				title="Credit Invoicing Request"
				open={isCreditInvoiceModalOpen}
				afterOpenChange={(open) => {
					if (!open && openTopupAfterCreditInvoiceClose) {
						setShowCreditInvoiceSuccessMessage(true);
						setIsEditModalOpen(true);
						setOpenTopupAfterCreditInvoiceClose(false);
					}
				}}
				onCancel={handleCloseCreditInvoiceModal}
				zIndex={3000}
				footer={[
					<Button key="cancel" onClick={handleCloseCreditInvoiceModal}>Cancel</Button>,
					<Button key="submit" type="primary" onClick={() => creditInvoiceForm.submit()}>Save</Button>,
				]}
				width={700}
			>
				<div className="mb-3">
					<p className="font-semibold mb-2">Please provide your invoicing details to be approved for credit invoicing:</p>
					<p className="text-xs text-gray-500 italic">*All invoices must be settled within the 30 day term or invoicing may be removed.</p>
				</div>
				<Form form={creditInvoiceForm} layout="vertical" onFinish={handleSaveCreditInvoice}>
					<Form.Item
						name="companyLegalName"
						label="Company Legal Name"
						rules={[{ required: true, message: 'Required field' }]}
					>
						<Input />
					</Form.Item>
					<div className="mb-3">
						<div className="mb-2 text-[14px] font-normal text-black-700">Company Address</div>
						<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
						<Form.Item
							name="companyAddress"
							label="Company Address"
							rules={[{ required: true, message: 'Required field' }]}
						>
							<Input.TextArea
    						autoSize={{ minRows: 3, maxRows: 6 }} />
						</Form.Item>
						{getCurrencyName(currencyContext.currency)==="GBP"?
							<Form.Item
								name="companyCity"
								label="Company City"
								rules={[{ required: true, message: 'Required field' }]}
							>
								<Input />
							</Form.Item>:null}
							{getCurrencyName(currencyContext.currency)==="GBP"||getCurrencyName(currencyContext.currency)==="EUR"?null:
							<Form.Item
								name="companyState"
								label="Company State"
								rules={[{ required: true, message: 'Required field' }]}
							>
								<Input />
							</Form.Item>}
							<Form.Item
								name="companyZip"
								label={getCurrencyName(currencyContext.currency)==="GBP"||getCurrencyName(currencyContext.currency)==="EUR"?"Company Postcode":"Company Zip"}
								rules={[{ required: true, message: 'Required field' }]}
							>
								<Input />
							</Form.Item>
							<Form.Item
								name="companyCountry"
								label="Company Country"
								rules={[{ required: true, message: 'Required field' }]}
							>
							<Select 
										//onChange={(e)=>onCountryslect(e)} 
								allowClear 
								showSearch
								loading={countryLoader} 
								placeholder={<span className='text-sm normal-case'>Select Country</span>}  
								className="w-60"
								filterOption={(input, option) =>
										(option?.props?.children ?? '').toLowerCase().includes(input.toLowerCase())
								}
								>
								<Option key="showall" value="showall">Show All</Option>
								<Option key="global" value="global">Global</Option>
								{countryList.map((item) => (
								<Option key={item.countryCode} value={item.countryCode}>{item.country}</Option>
								))}
								</Select>
							</Form.Item>
						</div>
					</div>
					<Form.Item
						name="invoiceEmail"
						label="Invoice Email"
						rules={[
							{ required: true, message: 'Required field' },
							{ type: 'email', message: 'Please enter a valid email address' },
						]}
					>
						<Input />
					</Form.Item>
				</Form>
			</Modal>
		</div>
   </>
	);
};

export default Orders;